import { render, staticRenderFns } from "./mine.vue?vue&type=template&id=2980a570"
import script from "./mine.vue?vue&type=script&lang=js"
export * from "./mine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports